import {capturePostHogEvent} from '/src/posthog';

export function logEvent(event_name: string, option?: string | number) {
    if (!(import.meta as any).env.PROD) return;
    if (window.gtag) {
        gtag('event', event_name, {
            app_name: 'lopaka',
            option: option,
        });
    }
    capturePostHogEvent(event_name, {option});
}
